import { useTranslation } from 'react-i18next';
import { cn } from '~/common/utils/styleUtil';
import { X } from 'lucide-react';
import { useHydrated } from 'remix-utils/use-hydrated';
import {
  useWebshopMessages,
  WEBSHOPMESSAGE_TYPE_GENERAL,
  WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT,
  WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT
} from '~/features/webshopmessages/hooks/useWebshopMessages';

export function WebshopMessageHeader() {
  const { t } = useTranslation();
  const isHydrated = useHydrated();
  const { visibleMessages, markAsRead, setIsDialogOpen } = useWebshopMessages();

  if (!isHydrated || visibleMessages.length === 0) {
    return null;
  }

  const visibleMessage = visibleMessages[0];

  return (
    <div
      className={cn(
        '',
        (visibleMessage.type === WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT ||
          visibleMessage.type === WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT) &&
          'bg-messages-important',
        visibleMessage.type === WEBSHOPMESSAGE_TYPE_GENERAL && 'bg-messages-general'
      )}
    >
      <div
        className={cn(
          '2xl:container 2xl:mx-auto flex px-4',
          (visibleMessage.type === WEBSHOPMESSAGE_TYPE_BGH_IMPORTANT ||
            visibleMessage.type === WEBSHOPMESSAGE_TYPE_AGH_IMPORTANT) &&
            'bg-messages-important',
          visibleMessage.type === WEBSHOPMESSAGE_TYPE_GENERAL && 'bg-messages-general'
        )}
      >
        <div suppressHydrationWarning={true} className={'flex-1'}>
          <button
            onClick={() => setIsDialogOpen(true)}
            type="button"
            className="flex text-white w-full text-left py-2 pl-5 flex-1"
          >
            <div className={'line-clamp-1'}>{visibleMessage.title}</div>
            {visibleMessages.length > 1 && (
              <div className="font-bold whitespace-nowrap">{` + ${visibleMessages.length - 1} ${t('weitere')}`}</div>
            )}
          </button>
        </div>

        <button onClick={() => markAsRead(visibleMessages[0])} type="button" className="text-white p-2 flex-none">
          <X />
        </button>
      </div>
    </div>
  );
}
